import { Center, Overlay, Stack, Title } from '@mantine/core';
import { Logo } from 'components/Logo/Logo';
import { i18nKeys, useTranslation } from 'locales';
import { motion } from 'motion/react';
import { memo, useRef } from 'react';
import { first, sample } from 'remeda';
import { isDevelopment } from 'shared/utils/environment';

const LOADING_FLAVOR_TEXTS = [
  'In a retro...',
  'Made you look',
  'Waking Niko...',
  'Inflating Celia...',
  'Let me out of here',
  'Writing standup...',
  "You're reading this",
  'Playing ping-pong...',
  'Now with AI bugs too',
  'It works on my machine',
  'Showing Pablo colors...',
  'Heading to the beach...',
  "Salting Pablo's water...",
  'Hiring more frontends...',
  'Whipping backend devs...',
  'Removing "legacy" code...',
  'The cool side of the stack',
  'Deleting the onboarding...',
  'LISTENING TO ALESS TALK...',
  'Setting deadhang records...',
  'Looking for my leatherman...',
  'Loading 7th payment model...',
  'Whipping the basement devs...',
  'Waiting for the test suite...',
  "Shining Andrea's bald head...",
  'Fetching even more private constants...',
];

export const LoadingScreen = memo(() => {
  const { t } = useTranslation();
  const flavorText = useRef(first(sample(LOADING_FLAVOR_TEXTS, 1)));

  return (
    <Overlay fixed color="#ffffff" backgroundOpacity={1}>
      <Center h="100%">
        <Stack align="center" gap="xl">
          <motion.div
            style={{ height: 200, width: 200 }}
            animate={{
              rotate: 360 * 3,
              transition: {
                repeat: Infinity,
                duration: 4,
                ease: [0.38, 0.89, 0.83, 0.37],
              },
            }}
          >
            <Logo width={200} height={200} />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Title ta="center" order={1}>
              {t(i18nKeys.LOADING)}
            </Title>
            {isDevelopment() && (
              <Title mt="sm" ta="center" order={5}>
                {flavorText.current}
              </Title>
            )}
          </motion.div>
        </Stack>
      </Center>
    </Overlay>
  );
});
